import { module } from "angular";
import { RequestPasswordResetComponent } from "./RequestPasswordResetComponent";

module("mmAuth").component("irRequestPasswordReset", new RequestPasswordResetComponent());
